import { PauseIcon, PlayIcon, VisuallyHidden } from '@ds/components'

import styles from './HeroPlayButton.module.css'

type THeroPlayButtonProps = {
    isPlaying: boolean
    onToggle: () => void
    playLabel: string
    pauseLabel: string
}

// Large round play/pause control shown to the left of the hero waveform. Presentational — playback
// state + toggle come from the container (useAudioPlayback over the shared dock).
export const HeroPlayButton = ({
    isPlaying,
    onToggle,
    playLabel,
    pauseLabel,
}: THeroPlayButtonProps) => (
    <button type="button" className={styles.button} onClick={onToggle} data-test="playback-button">
        {isPlaying ? <PauseIcon className={styles.icon} /> : <PlayIcon className={styles.icon} />}
        <VisuallyHidden>{isPlaying ? pauseLabel : playLabel}</VisuallyHidden>
    </button>
)
